// extracted by mini-css-extract-plugin
export var center = "_4r-2";
export var clickableRow = "_4r-5";
export var expandedRow = "_4r-7";
export var hoverable = "_4r-4";
export var left = "_4r-1";
export var right = "_4r-3";
export var row = "_4r-0";
export var selectedRow = "_4r-6";
export var summaryRow = "_4r-8";